import Avatar from './avatar'

Avatar.install = vue => vue.component(Avatar.name, Avatar)

export default Avatar
